import React from 'react';
import MedicationList from '../components/MedicationList';

const MedicationListPage: React.FC = () => <MedicationList />;

export default MedicationListPage;
